<template>
	<svg class="masking-border">
		<polygon ref="svg" :points="points[0]" :style="{strokeWidth: size}"/>
	</svg>
</template>

<script>
// animation
import anime from 'animejs'
// vuex
import { mapGetters } from 'vuex'

export default {
	name: 'masking-border',
	props: {
		visible: {
			type: Boolean,
			default: false
		},
		delay: {
			type: [String, Number]
		}
	},
	data () {
		return {
			size: 60
		}
	},
	computed: {
		...mapGetters({
			appWidth: 'width',
			appHeight: 'height'
		}),
		width: function () {
			return this.appWidth
		},
		height: function () {
			return this.appHeight
		},
		points: function () {
			return [
				`${this.size / 4},${this.size / 4} ${this.width - this.size / 4},${this.size / 4} ${this.width - this.size / 4},${this.height - this.size / 4} ${this.size / 4},${this.height - this.size / 4}`,
				`${this.size / 4},${this.size / 4} ${this.width - this.size / 4},${this.size / 4} ${this.width - this.size / 4},${this.height - this.size / 4} ${-this.size / 2},${this.height - this.size / 4}`,
				`${this.size / 4},${this.size / 4} ${this.width + this.size / 2},${this.size / 4} ${this.width - this.size / 4},${this.height - this.size / 4} ${-this.size / 2},${this.height - this.size / 4}`,
				`${-this.size / 2},${this.size / 4} ${this.width + this.size / 2},${this.size / 4} ${this.width - this.size / 4},${this.height - this.size / 4} ${-this.size / 2},${this.height - this.size / 4}`,
				`${-this.size / 2},${this.size / 4} ${this.width + this.size / 2},${this.size / 4} ${this.width + this.size / 2},${this.height - this.size / 4} ${-this.size / 2},${this.height - this.size / 4}`
			]
		}
	},
	watch: {
		visible (newValue, oldValue) {
			if (newValue) this.maskIn()
			else this.maskOut()
		}
	},
	methods: {
		maskIn () {
			if (this.animateShapeOutTimeline) this.animateShapeOutTimeline.pause()

			this.animateShapeInTimeline = anime.timeline({
				duration: 500,
				easing: 'easeOutQuint'
			})

			this.animateShapeInTimeline
				.add({
					targets: this.$refs.svg,
					points: this.points[1]
				})
				.add({
					targets: this.$refs.svg,
					points: this.points[2],
					offset: 100
				})
				.add({
					targets: this.$refs.svg,
					points: this.points[3],
					offset: 150
				})
				.add({
					targets: this.$refs.svg,
					points: this.points[4],
					offset: 200
				})

			this.animateShapeInTimeline.play()
		},
		maskOut () {
			if (this.animateShapeInTimeline) this.animateShapeInTimeline.pause()

			this.animateShapeOutTimeline = anime.timeline({
				duration: 700,
				delay: this.delay,
				easing: 'easeOutQuint'
			})

			this.animateShapeOutTimeline
				.add({
					targets: this.$refs.svg,
					points: this.points[3]
				})
				.add({
					targets: this.$refs.svg,
					points: this.points[2],
					offset: 100
				})
				.add({
					targets: this.$refs.svg,
					points: this.points[1],
					offset: 150
				})
				.add({
					targets: this.$refs.svg,
					points: this.points[0],
					offset: 200
				})

			this.animateShapeOutTimeline.play()
		}
	}
}
</script>

<style>
.masking-border{
	position: absolute;
	z-index: 1;
	top: 0;
	bottom: 0;
	left: 0;
	right: 0;
	width: 100%;
	height: 100%;
	pointer-events: none;
}

.masking-border polygon {
	fill: transparent;
	stroke: white;
}
</style>



// WEBPACK FOOTER //
// src/components/MaskingBorder.vue